import React, { useEffect, useRef } from 'react'
import type { InboxConversationDetail, ReviewerDisplayState } from './inboxTypes'
import { WriteMessageForm } from './WriteMessageForm'
import { ConversationPanelHeader } from './ConversationPanelHeader'
import { ConversationContent } from './conversation_content/ConversationContent'

interface ConversationPanelProps {
  conversation: InboxConversationDetail | null
  reviewerDisplayState: ReviewerDisplayState
  onIssueStatusChange?: () => void | Promise<void>
  onSendMessage: (messageBody: string) => void | Promise<void>
}

export const ConversationPanel: React.FC<ConversationPanelProps> = ({
  conversation,
  reviewerDisplayState,
  onIssueStatusChange,
  onSendMessage
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const conversationId = conversation?.id
  const messageCount = conversation?.messages.length ?? 0

  useEffect(() => {
    if (scrollRef.current == null) return
    scrollRef.current.scrollTop = scrollRef.current.scrollHeight
  }, [conversationId, messageCount])

  if (conversation == null) {
    return (
      <div />
    )
  }

  return (
    <div className='inbox-conversation-panel'>
      <ConversationPanelHeader conversation={conversation} />

      <div className='inbox-message-container'>
        <div className='inbox-message-scroll' ref={scrollRef}>
          <ConversationContent conversation={conversation} onIssueStatusChange={onIssueStatusChange} />
        </div>

        <div className='inbox-message-composer'>
          <WriteMessageForm
            conversationId={conversation.id}
            reviewerDisplayState={reviewerDisplayState}
            onSend={async (messageBody) => {
              await onSendMessage(messageBody)
              return undefined
            }}
            showShareWithSupplierCTA={conversation.review?.share_with_supplier === false}
            reviewAuthorName={conversation.review?.author?.name ?? ''}
          />
        </div>
      </div>
    </div>
  )
}
